import React, { useEffect, useRef, useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./Playlist.css"; // Custom styles (optional)
import AudioTracks from "./audioTracks";




const Playlist = (props) => {
  const playerRef = useRef();
  const [currentTrackIndex, setCurrentTrackIndex] = useState(undefined);
  const [autoPlay, setAutoPlay] = useState(false);
    

  useEffect(() => {
    console.log('[PROPS.status PLAY',props.statusPlay,props.id);
    if(!props.statusPlay) {
      playerRef.current.audio.current.pause();

      
    }
  },[props.statusPlay]); 
  const handleClick = (index) => {
    setAutoPlay(true);
    setCurrentTrackIndex(index);
  };

  const handleEnded = () => {
    setCurrentTrackIndex((prev) => (prev + 1) % props.voiceDemos.length);
  };

  const handlePlay = () => {
   if (!currentTrackIndex) {
      handleClick(0);
    }
  props.onPlayHandler(props.id);
  };

 
  return (
    <div className="voice-playlist-container">
      <h2 className="text-xl font-semibold mb-4 text-center">{props.title}</h2>
      <p>{props.description}</p>
    <div>
    <AudioPlayer
        ref={playerRef}
        id={props.id}
        autoPlay = {autoPlay}
        src={props.voiceDemos[currentTrackIndex]?.url||''}
        onEnded={handleEnded}
        showSkipControls={false}
        showJumpControls={false}
        onPlay={handlePlay}
      /> 
      <br/>
    </div>
    <AudioTracks
    voiceDemos={props.voiceDemos}
    currentTrackIndex={currentTrackIndex}
    handleClick={handleClick}
    />
    {/* <div className="audio-tracks-container">
      <ul className="demo-list mb-4">
        {props.voiceDemos.map((demo, index) => (
          <li
            key={demo.id}
            className={`demo-item ${
              index === currentTrackIndex ? "active" : ""
            }`}
            onClick={() => handleClick(index)}
          >
            {demo.title}
          </li>
        ))}
      </ul>
      </div> */}
    </div>
  );
};

export default Playlist;
